import i18n from "i18next";

import { messages } from "./languages";

i18n.init({
  debug: false,
  lng: "es",
  fallbackLng: "es",
  defaultNS: ["translations"],
  ns: ["translations"],
  resources: messages,
});

export { i18n };
